"use client";
import { AuthProvider } from "@wayak/auth/hooks/auth-hook";
import { GoogleAnalytics } from "@next/third-parties/google";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import { PostHogPageView } from "@/components/analytics/posthog-pageview";
import { PostHogRecordingController } from "@/components/analytics/posthog-recording-controller";

// Initialize at module scope so it runs before the pageview and recording
// effects below. This module is only loaded for non-embed routes.
if (
  typeof window !== "undefined" &&
  process.env.NEXT_PUBLIC_POSTHOG_KEY &&
  process.env.NEXT_PUBLIC_POSTHOG_HOST
) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    capture_pageview: false,
    disable_session_recording: true,
  });
}

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 2 * 60 * 1000, // 2 min default (medium churn)
            gcTime: 10 * 60 * 1000, // 10 min garbage collection
            retry: 1,
            refetchOnWindowFocus: true,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <PostHogProvider client={posthog}>
        <PostHogPageView />
        <PostHogRecordingController />
        <AuthProvider>{children}</AuthProvider>
        <GoogleAnalytics gaId="G-7TVFN4GGHD" />
        <Analytics />
      </PostHogProvider>
    </QueryClientProvider>
  );
}
